import React from 'react'
import AOSInit from '../../components/Animation/AOSInit'
import NavBarHome from '../../components/NavBar/NavBarHome'
import AnimatedSection from '../../components/Animation/AnimatedSection'
import Footer from '../../components/Footer/Footer'
import Masthead from './Masthead'
import WhyChooseGoNextMakerTutoring from './WhyChooseGoNextMakerTutoring'
import Howdoesitwork from './Howdoesitwork'
import OurTutoringPackages from './OurTutoringPackages'
import TestimonialsAndBook from './TestimonialsAndBook'
import ClientLogos from './ClientLogos'
import Faqs from './Faqs'
import ClosingSection from './ClosingSection'

function HomeTutorat() {
  return (
    <div className="pt-[92px] flex flex-col min-h-screen overflow-x-hidden">
      <AOSInit />
      <NavBarHome />

      {/* Hero Section */}
      <section id="hero" className="relative ">
        <AnimatedSection
          animation="fade-up"
          duration={1200}
          delay={100}
          threshold={1.0}
        >
          <Masthead />
        </AnimatedSection>
      </section>

      {/* WhyChooseGoNextMakerTutoring */}
      <section id="why-choose-gonextmaker" className="">
        <AnimatedSection
          animation="fade-up"
          duration={800}
          delay={200}
          threshold={1.0}
        >
          <WhyChooseGoNextMakerTutoring />
        </AnimatedSection>
      </section>

      {/* How does it work? */}
      <section id="how-does-it-work" className="bg-light-5 dark:bg-dark-1 ">
        <AnimatedSection
          animation="fade"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <Howdoesitwork />
        </AnimatedSection>
      </section>

      {/* Our Tutoring Packages */}
      <section id="our-tutoring-packages" className="">
        <AnimatedSection
          animation="fade-up"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <OurTutoringPackages />
        </AnimatedSection>
      </section>

      {/* Testimonials And Book */}
      <section id="testimonials-and-book" className="">
        <AnimatedSection
          animation="fade-up"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <TestimonialsAndBook />
        </AnimatedSection>
      </section>

      {/* Client Logos */}
      <section id="client-logos" className="">
        <AnimatedSection
          animation="fade"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <ClientLogos />
        </AnimatedSection>
      </section>

      {/* Faqs */}
      <section id="faqs" className="bg-light-4 dark:bg-dark-1 ">
        <AnimatedSection
          animation="fade-down"
          duration={800}
          delay={200}
          threshold={1.0}
        >
          <Faqs />
        </AnimatedSection>
      </section>

      {/* ClosingSection */}
      <section id="closing-section">
        <AnimatedSection
          animation="fade"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <ClosingSection />
        </AnimatedSection>
      </section>

      {/* Footer */}
      <section id="footer">
        <Footer
          logo={"/general/logo-pure-white.svg"}
          bgColor="bg-[#140342]"
          textColor="text-gray-100"
          borderColor="border-gray-400/20"
        />
      </section>
    </div>
  )
}

export default HomeTutorat